module.exports = __webpack_public_path__ + "3f16e137/img/at-icon.5d6fc5d8.svg";